(function () {
  function loadScript(src, attrs) {
    return new Promise((resolve, reject) => {
      if (!src) return resolve();
      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      if (attrs) {
        Object.keys(attrs).forEach((k) => s.setAttribute(k, attrs[k]));
      }
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function loadScripts(list) {
    if (!Array.isArray(list)) return;
    list.forEach((item) => {
      if (typeof item === "string") loadScript(item);
      else if (item && item.src) loadScript(item.src, item.attrs);
    });
  }

  function once(fn) {
    let done = false;
    return function () {
      if (done) return;
      done = true;
      fn();
    };
  }

  function onFirstInteraction(cb) {
    const run = once(cb);
    ["scroll", "mousemove", "touchstart", "keydown", "click"].forEach((evt) =>
      window.addEventListener(evt, run, { passive: true, once: true })
    );
  }

  function onTimeout(cb, ms) {
    setTimeout(cb, ms || 3000);
  }

  function onView(selector, cb, rootMargin) {
    const el = document.querySelector(selector);
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        cb();
      },
      { rootMargin: rootMargin || "300px" }
    );
    io.observe(el);
  }

  window.JINCHAN_LAZY = {
    loadOnInteraction: function (scripts) {
      onFirstInteraction(() => loadScripts(scripts));
    },
    loadOnTimeout: function (scripts, ms) {
      onTimeout(() => loadScripts(scripts), ms);
    },
    loadOnView: function (selector, scripts, rootMargin) {
      onView(selector, () => loadScripts(scripts), rootMargin);
    },
    loadScript,
  };
})();